import BackToTop from 'vue-backtotop'
import HeadView from '../../components/header_view'

export default {
  components: {
    BackToTop,
    HeadView
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/full.js